import configs from './styleProps';

/**
 * Strip any key/values that are associated with Utils (in the config)
 * @param input
 */
const stripStyleProps = (input: object): object =>
  Object.keys(input).reduce((acc, item) => {
    if (configs[item]) {
      return acc;
    }
    acc[item] = input[item];
    return acc;
  }, {});

export default stripStyleProps;
